import React from "react";

import {
  FaInfoCircle,
  FaCheckCircle,
  FaHeadset,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaDownload,
  FaIdCard,
  FaReceipt,
  FaFileAlt,
  FaShieldAlt,
  FaClipboardList,
  FaUsers,
  FaFilePdf,
  
} from "react-icons/fa";

import "./Downloads.css";


function Downloads() {

  const membershipDocuments = [
    {
      id: 1,
      title: "Membership ID Card",
      icon: <FaIdCard />,
      iconClass: "green",
      details: [
        "Member ID: APNBM240520001",
        "Generated on: 20 May 2024",
      ],
      size: "245 KB",
    },

    {
      id: 2,
      title: "Payment Receipt",
      icon: <FaReceipt />,
      iconClass: "orange",
      details: [
        "Payment Date: 20 May 2024",
        "Amount Paid: ₹1199.00",
      ],
      size: "182 KB",
    },

    {
      id: 3,
      title: "Membership Details",
      icon: <FaFileAlt />,
      iconClass: "purple",
      details: [
        "Generated on: 20 May 2024",
      ],
      size: "168 KB",
    },

    {
      id: 4,
      title: "Terms & Conditions",
      icon: <FaShieldAlt />,
      iconClass: "blue",
      details: [
        "Issued on: 20 May 2024",
      ],
      size: "156 KB",
    },

    {
      id: 5,
      title: "Welcome Letter",
      icon: <FaClipboardList />,
      iconClass: "red",
      details: [
        "Issued on: 20 May 2024",
      ],
      size: "142 KB",
    },

    {
      id: 6,
      title: "Benefits Guide",
      icon: <FaUsers />,
      iconClass: "yellow",
      details: [
        "Issued on: 20 May 2024",
      ],
      size: "110 KB",
    },
  ];


  const otherDocuments = [
    {
      name: "Claim Process Guide",
      description: "Step by step claim process",
      date: "18 May 2024",
      size: "1.2 MB",
    },

    {
      name: "Network Hospitals List",
      description: "List of empanelled hospitals",
      date: "18 May 2024",
      size: "1.5 MB",
    },

    {
      name: "Membership Certificate",
      description: "Official membership certificate",
      date: "20 May 2024",
      size: "215 KB",
    },

    {
      name: "Privacy Policy",
      description: "Privacy policy document",
      date: "10 May 2024",
      size: "320 KB",
    },
  ];


  const handleDownload = (documentName) => {

    /*
      Demo download.

      Replace this later with your actual backend PDF URL.
      Example:

      window.open(
        `/api/documents/${documentId}/download`,
        "_blank"
      );
    */

    const content = `
APNB SEVA SAMITHI & VIDYA CHARITABLE TRUST

Document: ${documentName}

Member ID: APNBM240520001
Member Name: Ramesh Babu

This is a demo membership document.
    `;

    const blob = new Blob(
      [content],
      { type: "application/pdf" }
    );

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download = `${documentName}.pdf`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  };


  return (

    <div className="downloads-page">


      {/* ==================================================
          PAGE HEADER
      ================================================== */}

      <div className="downloads-page-header">

        <h1>
          Downloads
        </h1>

      </div>


      {/* ==================================================
          MAIN DOWNLOADS LAYOUT
      ================================================== */}

      <div className="downloads-layout">


        {/* =================================================
            LEFT CONTENT
        ================================================= */}

        <main className="downloads-main">


          {/* ===============================================
              INFORMATION BANNER
          =============================================== */}

          <div className="downloads-info-banner">

            <FaInfoCircle />

            <span>
              Download your important membership documents
              and receipts.
            </span>

          </div>


          {/* ===============================================
              MEMBERSHIP DOCUMENTS
          =============================================== */}

          <section className="downloads-card">

            <h2>
              Membership Documents
            </h2>


            <div className="membership-documents-grid">

              {membershipDocuments.map((document) => (

                <div
                  className="membership-document"
                  key={document.id}
                >


                  <div
                    className={`document-icon ${document.iconClass}`}
                  >
                    {document.icon}
                  </div>


                  <div className="document-content">

                    <h3>
                      {document.title}
                    </h3>


                    {document.details.map(
                      (detail, index) => (

                        <p key={index}>
                          {detail}
                        </p>

                      )
                    )}


                    <div className="document-bottom">

                      <span className="document-size">

                        PDF

                        <span className="dot">
                          •
                        </span>

                        {document.size}

                      </span>


                      <button
                        type="button"
                        className="download-button"
                        onClick={() =>
                          handleDownload(
                            document.title
                          )
                        }
                      >

                        <FaDownload />

                        Download

                      </button>

                    </div>

                  </div>

                </div>

              ))}

            </div>

          </section>


          {/* ===============================================
              OTHER DOCUMENTS
          =============================================== */}

          <section className="downloads-card other-documents-card">

            <h2>
              Other Documents
            </h2>


            <div className="other-documents-table-wrapper">

              <table className="other-documents-table">

                <thead>

                  <tr>

                    <th>
                      Document Name
                    </th>

                    <th>
                      Description
                    </th>

                    <th>
                      Date
                    </th>

                    <th>
                      File Size
                    </th>

                    <th>
                      Action
                    </th>

                  </tr>

                </thead>


                <tbody>

                  {otherDocuments.map(
                    (document, index) => (

                      <tr key={index}>

                        <td>

                          <div className="other-document-name">

                            <FaFilePdf />

                            <span>
                              {document.name}
                            </span>

                          </div>

                        </td>


                        <td>
                          {document.description}
                        </td>


                        <td>
                          {document.date}
                        </td>


                        <td>
                          {document.size}
                        </td>


                        <td>

                          <button
                            type="button"
                            className="table-download-button"
                            onClick={() =>
                              handleDownload(
                                document.name
                              )
                            }
                          >

                            <FaDownload />

                            Download

                          </button>

                        </td>

                      </tr>

                    )
                  )}

                </tbody>

              </table>

            </div>

          </section>

        </main>


        {/* =================================================
            RIGHT SIDEBAR
        ================================================= */}

        <aside className="downloads-right">


          {/* ===============================================
              IMPORTANT INFORMATION
          =============================================== */}

          <section className="download-side-card information-card">

            <div className="side-card-title">

              <FaInfoCircle />

              <h3>
                Important Information
              </h3>

            </div>


            <div className="information-list">

              <div className="information-item">

                <FaCheckCircle />

                <span>
                  All documents are in PDF format.
                </span>

              </div>


              <div className="information-item">

                <FaCheckCircle />

                <span>
                  You need a PDF viewer to open the files.
                </span>

              </div>


              <div className="information-item">

                <FaCheckCircle />

                <span>
                  Keep your membership documents safe
                  for future reference.
                </span>

              </div>


              <div className="information-item">

                <FaCheckCircle />

                <span>
                  For any issues, contact our support team.
                </span>

              </div>

            </div>

          </section>


          {/* ===============================================
              NEED HELP
          =============================================== */}

          <section className="download-side-card help-card">

            <div className="side-card-title">

              <FaHeadset />

              <h3>
                Need Help?
              </h3>

            </div>


            <p className="help-description">
              Our support team is here to help you.
            </p>


            <div className="help-contact">

              <div>

                <FaPhone />

                <span>
                  +91 91234 56789
                </span>

              </div>


              <div>

                <FaEnvelope />

                <span>
                  support@apnbtrust.org
                </span>

              </div>


              <div>

                <FaClock />

                <span>
                  Mon - Sat: 9:00 AM - 6:00 PM
                </span>

              </div>

            </div>


            <button
              type="button"
              className="raise-ticket-button"
            >

              RAISE SUPPORT TICKET

            </button>

          </section>

        </aside>

      </div>

    </div>

  );
}


export default Downloads;